<template>
  <div class="table-header">
    <div class="table-row">
      <div class="table-th w200">INDENT ID</div>
      <div class="table-th w150">LR Number</div>
      <div :class="column.class" v-for="column in Headers" :key="column.id">{{column.label}}</div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    columns: Array,
  },
  data() {
    return {
      Headers: this.columns.map(column => Object.assign({}, column, { class: `table-th ${column.class}` })),
    };
  },
};
</script>
